// extracted by mini-css-extract-plugin
export default {"header":"header_header__TRXcv","headerTransformed":"header_headerTransformed__3mNi+","inner_content":"header_inner_content__evv9O","logo":"header_logo__I8ERj"};